import getUser from "../../store/user/actions/getUser";

import App from "./App";

export default {
    component: App,
    loadData: ({ dispatch }: any) => dispatch(getUser()),
    renderSeo: () => { },
};
